import React from "react";
import "../../Informations/Information.css";
import impaceathletejourney from "../../../Assets/impaceathletejourney.jpeg";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import dolar from "../../../Assets/dolar.jpg";
const ImpactAthleteJourney = () => {
  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="business-price-numbs">
          <div className="nill-img-text-hone">
            <div className="nill-img-aboutus">
              <img src={impaceathletejourney} alt="" />
            </div>
            <div>
              <h2 className="htwo-heading-aboutus">Why Support?</h2>
              <p className="text-aboutus">
                Supporting athletes helps them grow, develop, and succeed both
                on and off the field. By engaging with athletes, fans and
                supporters play a vital role in helping them maximize
                opportunities, showcase their talent, and build their personal
                brand. Every interaction, partnership, or engagement strengthens
                their journey and helps athletes reach their goals.
              </p>
              <p className="dolarimg-content">
                <img src={dolar} alt="" />
              </p>{" "}
            </div>
          </div>

          <div className="program-benefits-aboutus">
            <h2>
              Here are some reasons why making a contribution can be impactful:{" "}
            </h2>
            <h3> 1. Boost Visibility</h3>
            <p className="text-aboutus">
              {" "}
              Help athletes expand their reach and connect with fans, brands,
              and communities.
            </p>
            <h3>2. Encourage Growth</h3>
            <p className="text-aboutus">
              {" "}
              Support provides opportunities for athletes to showcase their
              skills and develop professionally.
            </p>
            <h3> 3. Foster Connections</h3>
            <p className="text-aboutus">
              {" "}
              Engaging with athletes builds stronger relationships between fans,
              brands, and athletes.
            </p>
            <h3> 4. Level the Playing Field</h3>
            <p className="text-aboutus">
              {" "}
              Support ensures athletes from all schools and backgrounds have
              access to opportunities.
            </p>
            <h3> 5. Build Trust and Credibility</h3>
            <p className="text-aboutus">
              {" "}
              Transparency and fair engagement create a reliable ecosystem for
              everyone involved.
            </p>
            {/* <h3> 6. Create a Sense of Community</h3>
            <p className="text-aboutus">
              {" "}
              By contributing, you’re not just supporting an athlete
              financially; you’re also helping to build a community of fans and
              supporters who are invested in their success. This fosters a
              stronger connection between the athlete and their fans, deepening
              relationships.
            </p> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ImpactAthleteJourney;

// import React from 'react'
// import "../../Informations/Information.css"
// import impaceathletejourney from "../../../Assets/impaceathletejourney.jpeg"
// import Header from '../../Header/Header'
// import Footer from '../../Footer/Footer'
// import dolar from "../../../Assets/dolar.jpg"
// const ImpactAthleteJourney = () => {
//     return (
//         <>
//             <Header />
//             <div className='page-main-container-aboutus'>
//                 <div className='business-price-numbs'>
//                     <div className='nill-img-text-hone'>
//                         <div className='nill-img-aboutus'>
//                             <img src={impaceathletejourney} alt="" />
//                         </div>
//                         <div>
//                             <h2 className='htwo-heading-aboutus' >Why Contribute?</h2>
//                             <p className='text-aboutus'>
//                                 Your generous contributions are essential in helping athletes stay at their current school, enabling them to continue their academic and athletic pursuits. By giving, you are actively supporting their development, both on and off the field. Your contribution helps create a lasting impact, so please consider showing your support today. Every contribution counts and brings them one step closer to achieving their goals.<br />
//                                 Here are some reasons why making a contribution can be impactful: </p>
//                             <p className='dolarimg-content'>
//                                 <img src={dolar} alt="" /></p> </div>
//                     </div>
//                     <div className='program-benefits-aboutus'>
//                         <h3> 1. Enhance NIL Opportunities</h3>
//                         <p className='text-aboutus'>  Contributions and support through NIL (Name, Image, and Likeness) deals can help athletes navigate opportunities to profit from their image and name. These funds can be used to cover a variety of expenses, from professional development to personal projects.</p>
//                         <h3>2. Help Cover Educational Expenses</h3>
//                         <p className='text-aboutus'>  For student-athletes, scholarships and contributions can be used to cover tuition, books, and other educational expenses. This allows them to focus on both their academic and athletic careers without the stress of financial burdens.</p>
//                         <h3> 3. Promote Mental and Physical Well-being</h3>
//                         <p className='text-aboutus'>  Contributions can fund services like sports therapy, injury prevention, mental health support, and recovery resources, helping athletes maintain their well-being throughout their careers.</p>
//                         <h3>  4. Foster a Positive Impact Beyond Sports</h3>
//                         <p className='text-aboutus'>  Many athletes use their platform to promote charitable causes, support communities, or engage in social justice efforts. Your contribution can help them continue to make a difference beyond just their sports career.</p>
//                         <h3> 5. Support Their Training and Development</h3>
//                         <p className='text-aboutus'> Contributions can help athletes access better training facilities, coaching, and equipment. This support ensures they have the resources to improve their skills, stay competitive, and reach their full potential.</p>
//                         <h3>  6. Create a Sense of Community</h3>
//                         <p className='text-aboutus'>  By contributing, you’re not just supporting an athlete financially; you’re also helping to build a community of fans and supporters who are invested in their success. This fosters a stronger connection between the athlete and their fans, deepening relationships.</p>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }
// export default ImpactAthleteJourney
